import { service } from '@ember/service';

import ApplicationAdapter from './application';

import type AuthService from 'later/services/auth';

export default class ListenerAdapter extends ApplicationAdapter {
  @service declare auth: AuthService;

  namespace = 'api/v2/social_listening_searches';
  serializer = 'listener';

  urlForCreateRecord(): string {
    return `${this.namespace}`;
  }

  urlForFindAll(): string {
    const groupId = this.auth.currentGroup.id;
    return `${this.namespace}?group_id=${groupId}`;
  }
}
